import { Component } from '@angular/core';


@Component({
    selector: 'dish-admin-footer',
    templateUrl: './admin-footer.component.html',
    styleUrls: ['./admin-footer.component.scss'],
    imports: []
})
export class AdminFooterComponent {
  currentYear = new Date().getFullYear();

  locations = [
    {
      name: 'Menu Management',
      links: [
        { label: 'Manage Week', href: '/Admin/Templates' },
        { label: 'Manager Templates', href: '/Admin/Templates/Manage' },
      ],
    },
    {
      name: 'Client Management',
      links: [
        { label: 'Add New Client', href: '/Admin/Clients/Create' },
        { label: 'All Clients', href: '/Admin/Clients' },
      ],
    },
    {
      name: 'Products Management',
      links: [
        { label: 'Corporate Products', href: '/Admin/CorporateProducts' },
        { label: 'Client Products', href: '/Admin/ClientProducts' },
      ],
    },
    {
      name: 'User Management',
      links: [{ label: 'Manage Users', href: '/Admin/ManageUsers' }],
    },
  ];
}
